import React, { useMemo } from 'react';

import { Button } from '@swyftx/aviary/atoms/Button/Button';
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from '@swyftx/aviary/atoms/Card';
import { StepperItem } from '@swyftx/aviary/atoms/StepperItem/StepperItem';
import { Body } from '@swyftx/aviary/atoms/Typography';
import { Help } from '@swyftx/aviary/icons/outlined';

import { useIntercom } from 'react-use-intercom';
import { StateNode } from 'xstate';

import { transformLoansStates } from './stepperUtils';
import { useLoanApplicationSelector } from '../../../xstate/LoanApplication.context';
import { loanApplicationMachine } from '../../../xstate/LoanApplication.machine';

const LoansStepper: React.FC = () => {
  const { show } = useIntercom();
  const currentState = useLoanApplicationSelector((state) => state.toStrings());
  const completedSteps = useLoanApplicationSelector((state) => state.context.completedSteps);

  const transformedSteps = useMemo(
    () => transformLoansStates(loanApplicationMachine.states as Record<string, StateNode>),
    [],
  );

  const [activeRootStepId, activeStepId] = useLoanApplicationSelector((state) => state.toStrings());

  const activeStepOrder = useMemo<number>(() => {
    const activeRootStep = transformedSteps.find((s) => s.id === activeRootStepId);

    if (!activeRootStep) return 0;

    if (!activeStepId) return activeRootStep.order;

    const activeStep = activeRootStep.children.find((s) => s.id === activeStepId);

    if (!activeStep) return activeRootStep.order;

    return activeStep.order;
  }, [transformedSteps, activeRootStepId, activeStepId]);

  return (
    <aside className='grid gap-8'>
      {transformedSteps.map((step, index) => (
        <StepperItem
          key={step.id}
          step={step}
          activeOrder={activeStepOrder}
          translationKey='loans'
          stepNumber={index + 1}
          currentState={currentState}
          completedSteps={completedSteps}
        />
      ))}
      <Card>
        <CardHeader>
          <CardTitle className='flex flex-row items-center gap-8 text-lg font-semibold'>
            <Help className='text-color-text-accent' />
            Need help?
          </CardTitle>
        </CardHeader>
        <CardContent>
          <Body>
            Our team is here to assist Mon-Fri 9AM-5PM AEST. Call us on <a href='#todo'>07 TODO TODO</a>, or start a
            live live chat below.
          </Body>
        </CardContent>
        <CardFooter>
          <Button variant='filled' onClick={show}>
            Chat to our team
          </Button>
        </CardFooter>
      </Card>
    </aside>
  );
};

export { LoansStepper };
